<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: {
      title: {
        required: true,
        type: String
      }
    }
  }
</script>
